import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbolWithFallback } from '@sg/common/src/lib/utils/currency-symbol.util';

@Pipe({
  name: 'sgCurrencySymbol',
  standalone: false,
})
export class SgCurrencySymbolPipe implements PipeTransform {
  transform(value: string, format: 'narrow' | 'wide' = 'narrow', locale?: string): string {
    return SgCurrencySymbolPipe.transform(value, format, locale);
  }

  static transform(value: string, format: 'narrow' | 'wide' = 'narrow', locale?: string): string {
    return getCurrencySymbolWithFallback(value, format, locale);
  }
}
